import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  messageAvatar: {
    height: '2rem',
    width: '2rem'
  },
  messageListItem: {
    alignItems: 'flex-start',
    paddingLeft: 0
  },
  messageListItemAvatar: {
    minWidth: 0
  }
}));

export default useStyles;
